(function() {
	const initBlogsSliders = () => {
		$(".featured-blogs").each(function() {
			if ($(this).hasClass("slider_started")) {
				return;
			}
			$(this).addClass("slider_started");
			const id = $(this).data("id");
			const autoplay = $(this).data("autoplay");
			const delay = $(this).data("delay") * 1000;
			const perRow = $(this).data("per_row");
			const mobileSliderPerRow = $(this).data("mobile-slider-per-row");
			// "Mobile: show 2 cards per row" section setting — defaults to true
			// via the data attribute (jQuery parses the literal "true"/"false"
			// string into a boolean), so a base slidesPerView of 2 shows two
			// cards side by side under 576px, with the existing swiper
			// pagination dots below to page through the rest.
			const mobileColumns = $(this).data("mobile-columns");
			const mobileBaseSlidesPerView = mobileColumns === false ? 1 : 2;

			let breakpoints;
			if (mobileSliderPerRow) {
				breakpoints = {
					576: {
						slidesPerView: 1,
					},
					1150: {
						slidesPerView: perRow,
					},
				};
			} else {
				breakpoints = {
					576: {
						slidesPerView: perRow >= 2 ? 2 : 1,
					},
					750: {
						slidesPerView: perRow >= 3 ? 3 : perRow,
					},
					990: {
						slidesPerView: perRow >= 4 ? 4 : perRow,
					},
					1150: {
						slidesPerView: perRow,
					},
				};
			}

			let swiperParams = {
				speed: $(this).data("speed") * 1000,
				slidesPerView: mobileBaseSlidesPerView,
				spaceBetween: 16,
				loop: false,
				// Touch swipe on phones and tablets, mouse drag on desktop, and
				// horizontal trackpad / mouse-wheel scrolling (2026-10-15).
				// forceToAxis keeps vertical page scrolling untouched: only a
				// horizontal wheel gesture moves the slider.
				allowTouchMove: true,
				simulateTouch: true,
				grabCursor: true,
				threshold: 5,
				touchStartPreventDefault: false,
				preventClicks: true,
				preventClicksPropagation: true,
				mousewheel: {
					forceToAxis: true,
					sensitivity: 1,
					releaseOnEdges: true,
				},
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				breakpoints: breakpoints,
			};

			if (autoplay) {
				swiperParams.autoplay = {
					delay: delay,
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
				};
			}

			new Swiper(`#${id} .swiper`, swiperParams);
		});
	};

	document.addEventListener("DOMContentLoaded", function() {
		initBlogsSliders();
		document.addEventListener("shopify:section:load", function () {
			initBlogsSliders();
		});
	});
})();